'use client';
import React from 'react';
import IconFont from '@/components/ui/iconFont';

interface ModalTitleProps {
  title?: string;
  className?: string;
  onBack?: () => void;
  onClose?: () => void;
  showBack?: boolean;
  showClose?: boolean;
}

const ModalTitle = ({ title, onBack, onClose, showBack = true, showClose = true, className }: ModalTitleProps) => {
  const handleBack = (e: React.MouseEvent) => {
    e.stopPropagation();
    onBack?.();
  };
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose?.();
  };
  return (
    <div className={`flex items-center justify-between w-full px-5 pt-[25px] ${className}`}>
      {showBack ? (
        <div
          onClick={handleBack}
          className='relative inline-flex cursor-pointer active:scale-90'
        >
          <div className='absolute inset-[-0.5rem]' />
          <IconFont name="arrow-back" size={16} />
        </div>
      ) : <div className='w-2.5 h-[.9375rem]' />}
      <p className='font-semibold text-left text-base text-white leading-3'>{title}</p>
      {showClose ? (
        <div
          onClick={handleClose}
          className='relative inline-flex cursor-pointer active:scale-90'
        >
          <div className='absolute inset-[-0.5rem]' />
          <IconFont name="close" size={12} />
        </div>
      ) : <div className='w-[.8125rem] h-[.8125rem]' />}
    </div>
  );
};

export default ModalTitle;
